const _excluded = ["pollingInterval", "onSuccess", "onError"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState } from 'react';
import { Button } from 'seagull';
import { useStore, useStoreActions } from "../../../../contexts";
import { useIntegrations } from "../../../../hooks/useIntegrations";
import { integrationsModel } from "../../../../models/integrations";
import { selectors } from "../../../../store/state-selectors";
export function RefreshQboButton(props) {
  const {
    pollingInterval = 1000,
    onSuccess,
    onError
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  const inProgress = useStore(selectors.integration.qboInProgress);
  const {
    fetchIntegrations,
    logBI
  } = useStoreActions();
  const {
    syncIntegrationData
  } = useIntegrations();
  const vendorId = useStore(selectors.user.businessId);
  const userId = useStore(selectors.user.id);
  const [isRefreshing, setIsRefreshing] = useState(inProgress);

  const refreshQboIntegrationData = async () => {
    return new Promise((resolve, reject) => {
      const refreshData = async () => {
        logBI(12013, {
          vendorId,
          userId
        });
        const [, error] = await syncIntegrationData();

        if (error) {
          reject(new Error('Failed to refresh QuickBooks data, please try again'));
          return;
        }

        const intervalId = setInterval(async () => {
          const integrations = await fetchIntegrations(); //no need for error handling - continue until you die

          const integration = integrationsModel.qboIntegration(integrations);

          if (integration && integration.dataSyncStatus !== 'inProgress') {
            clearInterval(intervalId);
            resolve({
              integration
            });
          }
        }, pollingInterval);
      };

      refreshData();
    });
  };

  return /*#__PURE__*/React.createElement(Button, _extends({
    loading: isRefreshing,
    loadingText: "Refreshing...",
    "data-testid": "refresh-now-button",
    onClick: async () => {
      setIsRefreshing(true);

      try {
        const {
          integration
        } = await refreshQboIntegrationData();
        onSuccess(integration);
      } catch (e) {
        onError(e.message);
      } finally {
        setIsRefreshing(false);
      }
    },
    style: {
      minWidth: 168
    }
  }, rest), "Refresh");
}